export const LAST_MONTH_NUMBER = 11;
export const FIRST_MONTH_NUMBER = 0;

export const SEVEN_DAY_OF_MONTH = 7;

export const INVALID_DATE_TEXT = 'Invalid Date';
export const NEAREST_EVENTS_TITLE_TEXT = 'Ближайшие события';
export const NEAREST_EVENT_TITLE_TEXT = 'Ближайшее событие';

export const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];

export const monthsMap: Record<string, string> = {
    '01': 'января',
    '02': 'февраля',
    '03': 'марта',
    '04': 'апреля',
    '05': 'мая',
    '06': 'июня',
    '07': 'июля',
    '08': 'августа',
    '09': 'сентября',
    '10': 'октября',
    '11': 'ноября',
    '12': 'декабря',
};
